<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <button @click="back" class="btn btn-outline-secondary btn-icon-text py-2 px-3 mr-3">
            <i class="mdi mdi-arrow-left mr-1"></i> {{ $t('common.back') }}
          </button>
          <div>
            <h2 class="text-white font-weight-bold mb-1">
              <i class="mdi mdi-lead-pencil text-warning mr-1"></i>
              {{ $t('squad.editTitle') }}
            </h2>
            <p class="text-muted small mb-0">
              {{ $t('squad.editSubtitle') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Form Card -->
    <div class="col-12 grid-margin">
      <div class="card border border-secondary">
        <div class="card-body p-4">
          <form class="forms-sample" method="post" @submit.prevent="submitForm">
            <div class="form-group row">
              <div class="col-md-8 mb-3">
                <label for="nameInput" class="text-muted small text-uppercase font-weight-bold">
                  {{ $t('squad.name') }}
                </label>
                <input
                  id="nameInput"
                  type="text"
                  class="form-control"
                  v-model="ruleStore.name"
                  :placeholder="$currentLocale === 'id' ? 'Contoh: Penjualan & Pertumbuhan, Rekayasa & DevOps' : 'e.g. Sales & Growth, Engineering & DevOps'"
                  required
                />
              </div>
            </div>

            <div class="d-flex justify-content-end gap-2 mt-4">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-2"
                :disabled="loading"
              >
                {{ $t('common.back') }}
              </button>
              <button
                type="submit"
                class="btn btn-primary px-4 py-2 font-weight-bold"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-1" role="status"></span>
                <i v-else class="mdi mdi-check-all mr-1"></i>
                {{ $t('common.save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDetailSquad, updateSquad } from "../../services/squadService";
import Swal from 'sweetalert2';

export default {
  name: 'EditSquad',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    ruleStore: {
      name: '',
    },
    loading: false,
  }),
  methods: {
    back() {
      this.$router.go(-1);
    },
    async submitForm() {
      if (!this.ruleStore.name || !this.ruleStore.name.trim()) {
        Swal.fire({
          icon: 'warning',
          title: this.$currentLocale === 'id' ? 'Input Kosong' : 'Empty Input',
          text: this.$currentLocale === 'id' ? 'Nama Tim / Divisi wajib diisi.' : 'Team / Division name is required.',
          confirmButtonColor: '#3b82f6'
        });
        return;
      }
      try {
        this.loading = true;
        await updateSquad(this.id, this.ruleStore);
        Swal.fire({
          icon: "success",
          title: this.$t('common.success'),
          text: this.$t('squad.savedSuccess'),
          confirmButtonColor: "#3b82f6",
        });

        this.$router.push('/squad');
      } catch (error) {
        const msg = error.response?.data?.message || (this.$currentLocale === 'id' ? 'Gagal memperbarui divisi.' : 'Failed to update division.');
        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: msg,
          confirmButtonColor: '#ef4444',
        });
      } finally {
        this.loading = false;
      }
    },
    async fetchSquad() {
      try {
        const response = await getDetailSquad(this.id);
        this.ruleStore.name = response.data?.name || '';
      } catch (err) {
        console.error('Error fetching squad details:', err);
      }
    },
  },
  mounted() {
    this.fetchSquad();
  }
};
</script>
